/* eslint-disable @next/next/no-img-element */
import { ReactNode } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  position: relative;
`;

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 400px;
  position: absolute;
  z-index: 10;
  height: 100%;
  width: 100%;

  img {
    height: 25vh;
  }
`;

// .loading-star - test selector
function LoadingIcon() {
  return (
    <Wrapper className="loading-star">
      <img src="/img/shared/star-loader.gif" alt="loader" />
    </Wrapper>
  );
}

type LoadingContainerProps = {
  isLoading: boolean;
  className?: string;
  children?: ReactNode;
};

function LoadingContainer({ className, isLoading, children }: LoadingContainerProps): JSX.Element {
  return (
    <Container className={className}>
      {isLoading ? <LoadingIcon /> : null}
      {children}
    </Container>
  );
}

export default LoadingContainer;
